
import { PPTFieldInclusions } from "@/common/constants";
import React from "react";

export interface NoPptPreviewContextType {
  hasPptPreview: boolean
  checkSectionAndField: (section: string, fieldName?: string) => boolean
}

export const NoPptPreviewContext = React.createContext<NoPptPreviewContextType | undefined>(undefined);

export const useNoPptPreviewContext = () => {
  const context = React.useContext(NoPptPreviewContext);
  if (!context) {
    throw new Error("useNoPptPreviewContext must be used within a NoPptPreviewProvider");
  }
  return context;
};

export const createNoPptPreviewFunc = (
  pptPreviewEnabled: boolean,
  fieldInclusions: PPTFieldInclusions
): NoPptPreviewContextType => {
  return {
    hasPptPreview: pptPreviewEnabled,
    checkSectionAndField: (section: string, fieldName?: string) => {
      if (!pptPreviewEnabled || !fieldInclusions) {
        return false;
      }

      const sectionInclusion = fieldInclusions[section];
      if (!sectionInclusion) {
        return false;
      }

      if (!fieldName) {
        // Only section provided - check includeAll
        return !sectionInclusion.includeAll && sectionInclusion.includeFields.length < 1;
      } else {
        // Both section and field provided - check if field is in includeFields
        return !sectionInclusion.includeAll && !sectionInclusion.includeFields.includes(fieldName);
      }
    }
  };
};
